import * as React from "react";
import PropTypes from 'prop-types';
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment";
import {Chip} from "@mui/material";
import Typography from "@mui/material/Typography";
import {UserRole } from "../../../utils/consts";
import "../../../utils/timezone";

export const renderTableCellForServicerStatus = (trsiiOptIn, optOutFlag, userRole) => {
    const chipStyle = {
        // variant: "outlined",
        width: '200px',
        color: "default",
    };

    let servicerStatus = "";
    if (userRole === UserRole.ADMIN) {
        if (trsiiOptIn === 0 && optOutFlag === 1) {
            servicerStatus = "Opted in for Public Scoring";
        } else if (trsiiOptIn === 1 && optOutFlag === 1) {
            servicerStatus = "Rejected by HUD";
        } else if (trsiiOptIn == 0 && optOutFlag == 0) {
            servicerStatus = "Submitted for HUD approval";
        }
    }


    return (
        <TableCell align="left">
            <Chip
                sx={chipStyle.width}
                variant={chipStyle.variant}
                color={chipStyle.color}
                label={servicerStatus}
            />
        </TableCell>
    );
};

const ServicerTableForAdmin = ({ servicerList, userRole }) => {

    return (
        <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2 }}>

                <TableContainer>
                   

                    <Table sx={{ minWidth: 900 }} aria-labelledby="tableTitle">
                    <ServicerTableHead
                    />
                        <TableBody>
                            {servicerList.map((servicer) => {
                                const {
                                    id: servicerId,
                                    servicerMasterName,
                                    trsiiOptIn,
                                    optOutFlag,
                                    approvedDate
                                } = servicer;

                                return (
                                    <TableRow key={servicerId}>
                                        <TableCell component="th" scope="row" align="left">
                                            {servicerId}
                                        </TableCell>
                                        <TableCell align="left">{servicerMasterName}</TableCell>
                                        <TableCell align="left">{moment(approvedDate).format('MM-DD-YYYY')}</TableCell>
                                        <TableCell align="left">{renderTableCellForServicerStatus(trsiiOptIn, optOutFlag, userRole)}
                                        </TableCell>

                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};

ServicerTableForAdmin.propTypes = {
    servicerList: PropTypes.arrayOf(
      PropTypes.shape({
        // Define the expected shape of each servicer object
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        // Add more properties as needed
      })
    ).isRequired,
    userRole: PropTypes.string.isRequired,
};
const headCells = [
    { label: "Servicer ID" },
    { label: "Servicer Name" },
    {label: "Approved Date"},
    { label: "Opt Out Status" },
];

function ServicerTableHead() {
    return (
        <TableHead>
          <TableRow
            sx={{
              backgroundColor: `rgba(210, 174, 27, 0.1)`,
              fontWeight: 1000,
              borderBottom: "initial",
            }}
          >
            {headCells.map((headCell) => (
              <TableCell key={headCell.servicerId} sx={{ pr: "0px" }}>
                <Typography variant="subtitle" noWrap>
                  <b>{headCell.label}</b>
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      );
}

export default ServicerTableForAdmin;
